<!--
 * @Description: 
 * @Author: liulan
 * @Date: 2021-05-07 10:08:06
 * @LastEditors: liulan
 * @LastEditTime: 2021-05-10 16:42:13
 * @FilePath: \xingmahui_front\src\views\canEatList\components\BlackWhiteItem.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->

<template>
<!-- 能不能吃黑白榜分类组件 -->
<div class="need" @click.stop="handleSorting(blackWhiteItem.type, blackWhiteItem.title )">
  <div class="need_item" >
    <div class="con"
    :style="{background: 'url('+blackWhiteItem.bgUrl+')',
      backgroundSize:'100% 100%',
      backgroundRepeat:'no-repeat',
      backgroundPosition:'center center'}">
      <span :style="blackWhiteItem.type | color">{{blackWhiteItem.title}}
      </span>
      <img class="pic" :src="blackWhiteItem.iconUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: 'BlackWhiteItem',
    data() {
      return {}
    },
    props: {
      blackWhiteItem: Object,
      monthAge: Number
    },
    methods: {
      handleSorting(type, title) {
        this.$emit('handleblackWhiteFn', type, this.monthAge, title)
      }
    }
  }
</script>

<style lang="less" scoped>
.need{
  width: 25%;
  padding: 0 4px;
  box-sizing: border-box;
}
.need_item {
  width: 100%;
  display: flex;
  box-shadow: 0px 0px 24px 0px #eeeeee;
  border-radius: 4px;
  .con {
    width: 82px;
    height: 50px;
    padding: 6px 5px 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 2px;
      font-weight: 500;
    }
    .pic {
      width: 6px;
      height: 9px;
    }
  }
}
</style>